import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { frameSettings } from "shared/utils/doorConfigurations";
import { Color, MeshStandardMaterial } from "three";

interface FrameProps extends frameSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const Frame: React.FC<FrameProps> = ({
  doorNodes,
  materials,
  index,
  ...props
}: FrameProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height);
  const scaling = getFrameScaling(width, height);

  return (
    <group dispose={null}>
      <mesh
        geometry={doorNodes["frame_bottom"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={positions.bottom}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_left"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.left.x - 0.86 * (1 - scaling.horizontal.x), 0, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_right"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.right.x + 0.86 * (1 - scaling.horizontal.x), 0, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_top"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.horizontal.x,
          props?.frameTop?.scaleY ?? scaling.horizontal.y,
          scaling.horizontal.z,
        ]}
        position={[
          positions.top.x,
          positions.top.y + (props?.frameTop?.shiftY ?? 0),
          0,
        ]}
      ></mesh>

      {props?.hingeTop?.enabled !== false && (
        <mesh
          rotation={[
            0,
            props?.hingeTop?.rotateY ?? Math.PI,
            props?.hingeTop?.rotateZ ?? 0,
          ]}
          geometry={doorNodes["misc_0"].geometry}
          material={materials["PoedercoatGitZwart"]}
          position={[
            props?.hingeTop?.recalculateHingePos
              ? positions.left.x -
                (0.96 * width) / 1000 -
                0.86 * (1 - scaling.horizontal.x)
              : positions.left.x -
                (props?.hingeTop?.scalingHorizontalShift ?? 0.86) *
                  (1 - scaling.horizontal.x) +
                (props?.hingeTop?.shiftX ?? 0),

            positions.top.y +
              (props?.hingeTop?.shiftY ?? 0) -
              (props?.hingeTop?.scalingVerticalShift
                ? (props?.hingeTop?.scalingVerticalShiftValue ?? 0.18) *
                  (-1 * (1 - scaling.vertical.y))
                : 0),

            props?.hingeTop?.shiftZ ?? 0,
          ]}
        ></mesh>
      )}

      {props?.hingeBottom?.enabled !== false && (
        <mesh
          rotation={[
            0,
            props?.hingeBottom?.rotateY ?? Math.PI,
            props?.hingeBottom?.rotateZ ?? 0,
          ]}
          geometry={doorNodes["misc_1"].geometry}
          material={materials["PoedercoatGitZwart"]}
          position={[
            props?.hingeBottom?.recalculateHingePos
              ? positions.left.x -
                (0.96 * width) / 1000 -
                0.86 * (1 - scaling.horizontal.x)
              : positions.left.x -
                (props?.hingeTop?.scalingHorizontalShift ?? 0.86) *
                  (1 - scaling.horizontal.x) +
                (props?.hingeBottom?.shiftX ?? 0),

            positions.bottom.y + (props?.hingeBottom?.shiftY ?? 0),
            props?.hingeBottom?.shiftZ ?? 0,
          ]}
        ></mesh>
      )}
    </group>
  );
};

export default Frame;
